import '../../../external/jquery.fancybox.min.js';

export const initFancybox = () => {
    return null
};
